<div class="play-pause" [ngClass]="{'small': !!media}">
  <button mat-icon-button class="play-pause-icon" [disabled]="(isInBlacklist$ | async)"
          [ngClass]="{blacklisted: (isInBlacklist$ | async)}"
          *ngIf="(!(isPlaying$ | async) && isGoodMedia) || !isGoodMedia"
          (click)="play()">
    <img class="action" src="/assets/icons/play-playlist.svg" alt="play icon" />
  </button>
  <button mat-icon-button class="play-pause-icon" *ngIf="(isPlaying$ | async) && isGoodMedia" (click)="pause()">
    <img class="action" src="/assets/icons/pause-playlist.svg" alt="pause icon" />
  </button>
</div>
